import React from "react";
import { ReactComponent as MovimentiIcon } from "../../../assets/new-icons/movimenti.svg";
import { ReactComponent as UserIcon } from "../../../assets/new-icons/user.svg";
import { ReactComponent as FattureIcon } from "../../../assets/new-icons/doc.svg";
import { ReactComponent as ConsumiIcon } from "../../../assets/new-icons/consumi.svg";
import './_boxPages.scss'
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

function BoxPages() {
  const navigate = useNavigate();
  const section = useSelector((user) => user.settings.section);
  return section ? (
    <div className="boxPages">
      <div className="boxPage" onClick={() => navigate("/enrica/gas/movimenti")}>
        <div className="boxIcon">
          <MovimentiIcon />
        </div>
        <p className="label">Movimenti</p>
      </div>
      <div className="boxPage" onClick={() => navigate("/enrica/gas/consumi")}>
        <div className="boxIcon">
          <ConsumiIcon />
        </div>
        <p className="label">Consumi</p>
      </div>
      <div className="boxPage" onClick={() => navigate("/enrica/gas/fatture")}>
        <div className="boxIcon">
          <FattureIcon />
        </div>
        <p className="label">Fatture</p>
      </div>
      <div className="boxPage" onClick={() => navigate("/enrica/gas/profilo")}>
        <div className="boxIcon">
          <UserIcon />
        </div>
        <p className="label">Profilo</p>
      </div>
    </div>
  ) : (
    <div className="boxPages">
      <div className="boxPage" onClick={() => navigate("/enrica/movimenti")}>
        <div className="boxIcon">
          <MovimentiIcon />
        </div>
        <p className="label">Movimenti</p>
      </div>
      <div className="boxPage" onClick={() => navigate("/enrica/consumi")}>
        <div className="boxIcon">
          <ConsumiIcon />
        </div>
        <p className="label">Consumi</p>
      </div>
      <div className="boxPage" onClick={() => navigate("/enrica/fatture")}>
        <div className="boxIcon">
          <FattureIcon />
        </div>
        <p className="label">Fatture</p>
      </div>
       <div className="boxPage" onClick={() => navigate("/enrica/profilo")}>
        <div className="boxIcon">
          <UserIcon />
        </div>
        <p className="label">Profilo</p>
      </div>
    </div>
  );
}

export default BoxPages;
